import type { Topic } from './apiModels'

/** Notification bundles contain only their target, never a complete list. */
export function mergeTopicUpdates(current: Topic[], updates: Topic[]): Topic[] {
  const byId = new Map(current.map((topic) => [topic.id, topic]))
  for (const topic of updates) byId.set(topic.id, topic)
  return [...byId.values()]
}
